import React, { CSSProperties, useEffect, useMemo, useState } from "react";
import { chunk, concat, get, map, orderBy, reduce, sumBy } from "lodash";
import Table from "./Table";
import { useSelector } from "react-redux";
import { selectStatGroupByPlayerByRound } from "../store/betStatsSlice";
import { getPlayerMappingByPlayerId } from "../store/playerSlice";
import AnimationNumber from "./AnimationNumber";
import { selectGroupByRound } from "../store/groupSlice";
import { useSearchParams } from "react-router-dom";

const ranking = [
  { rank: 1, order: 3 },
  { rank: 2, order: 2 },
  { rank: 3, order: 4 },
  { rank: 4, order: 1 },
  { rank: 5, order: 5 },
];
function FirstRound() {
  const playersMapping = useSelector(getPlayerMappingByPlayerId);
  const selectGroup = useSelector((state: any) =>
    selectGroupByRound(state, "first")
  );
  const statByPlayer = useSelector((state: any) =>
    selectStatGroupByPlayerByRound(state, "first")
  );
  const [searchParams] = useSearchParams();
  //     id: "4",
  //     name: "002",
  //     chip: 1900000,
  //   },
  //   {
  //     id: "3",
  //     name: "001",
  //     chip: 740000,
  //   },
  //   {
  //     id: "5",
  //     name: "003",
  //     chip: 690000,
  //   },
  //   {
  //     id: "6",
  //     name: "004",
  //     chip: 610000,
  //   },
  //   {
  //     id: "7",
  //     name: "005",
  //     chip: 100000,
  //   },
  //   {
  //     id: "1",
  //     name: "11111",
  //     chip: 0,
  //   },
  //   {
  //     id: "2",
  //     name: "001",
  //     chip: 0,
  //   },
  //   {
  //     id: "8",
  //     name: "006",
  //     chip: 0,
  //   },
  //   {
  //     id: "9",
  //     name: "007",
  //     chip: 0,
  //   },
  //   {
  //     id: "10",
  //     name: "008",
  //     chip: 0,
  //   },
  //   {
  //     id: "11",
  //     name: "009",
  //     chip: 0,
  //   },
  //   {
  //     id: "12",
  //     name: "010",
  //     chip: 0,
  //   },
  //   {
  //     id: "13",
  //     name: "011",
  //     chip: 0,
  //   },
  //   {
  //     id: "14",
  //     name: "012",
  //     chip: 0,
  //   },
  //   {
  //     id: "15",
  //     name: "013",
  //     chip: 0,
  //   },
  //   {
  //     id: "16",
  //     name: "tetet",
  //     chip: 0,
  //   },
  //   {
  //     id: "17",
  //     name: "014",
  //     chip: 0,
  //   },
  //   {
  //     id: "18",
  //     name: "015",
  //     chip: 0,
  //   },
  //   {
  //     id: "19",
  //     name: "test",
  //     chip: 0,
  //   },
  //   {
  //     id: "20",
  //     name: "016",
  //     chip: 0,
  //   },
  //   {
  //     id: "21",
  //     name: "017",
  //     chip: 0,
  //   },
  //   {
  //     id: "22",
  //     name: "018",
  //     chip: 0,
  //   },
  //   {
  //     id: "23",
  //     name: "019",
  //     chip: 0,
  //   },
  //   {
  //     id: "24",
  //     name: "020",
  //     chip: 0,
  //   },
  //   {
  //     id: "25",
  //     name: "021",
  //     chip: 0,
  //   },
  // ]);

  const cols = useMemo(() => {
    return [
      {
        key: "name",
        col: 5,
        format: (val: string | number) => (
          <div className="d-flex gap-2 align-items-center">
            {/* <img
              alt="profile"
              src="/assets/profile-user.svg"
              width={32}
              height={32}
              loading="eager"
            /> */}
            <div>{val}</div>
          </div>
        ),
      },
      // {
      //   key: "shoe",
      //   col: 1,
      //   className: "justify-content-center",
      // },
      // {
      //   key: "point",
      //   col: 2,
      //   className: "justify-content-end",
      // },
      {
        key: "chip",
        col: 6,
        className: "justify-content-end px-3",
        format: (val: string | number) =>
          val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","),
      },
    ];
  }, []);

  const emptyPlayers = useMemo(() => {
    return map(Array(25), (_, index) => ({
      id: `empty-${index}`,
      name: "",
      chip: 0,
      winStack: 0,
    }));
  }, []);

  const groups = useMemo(() => {
    let group = 1;
    try {
      group = parseInt(searchParams.get("group") ?? "1");
    } catch (error) {}
    const playerIds = reduce(
      selectGroup,
      (result, item) => {
        if (item.group === group) {
          return concat(result, item.players);
        }
        return result;
      },
      [] as string[]
    );
    const players = reduce(
      playersMapping,
      (result, player, index) => {
        if (player.id && playerIds.includes(player.id)) {
          const stat = get(statByPlayer, player.id, []);
          result.push({
            id: player?.id,
            name: player?.nickname ?? "",
            chip: player?.id ? sumBy(stat, "totalBalance") : 0,
            winStack: player?.id ? sumBy(stat, "maxWinStackTimes") : 0,
          });
        }
        return result;
      },
      [] as Array<{ id: string; name: string; chip: number; winStack: number }>
    );
    console.log(
      concat(
        orderBy(
          players,
          ["chip", "winStack", "name"],
          ["desc", "desc", "desc"]
        ),
        emptyPlayers
      ).slice(0, 25)
    );
    return concat(
      orderBy(players, ["chip", "winStack", "name"], ["desc", "desc", "desc"]),
      emptyPlayers
    ).slice(0, 25);
  }, [selectGroup, playersMapping, emptyPlayers, searchParams, statByPlayer]);

  return (
    <div className={`position-relative`}>
      <img
        alt="coin"
        src="/assets/coin1.png"
        className="animate-floating position-absolute"
        width={90}
        style={
          {
            top: "-23%",
            left: "25%",
            rotate: "60deg",
            "--animation-delay": "1s",
            "--animation-duration": "3s",
          } as CSSProperties
        }
      />
      <img
        alt="coin"
        src="/assets/coin1.png"
        className="animate-floating position-absolute"
        width={48}
        style={
          {
            top: "-10%",
            right: "28%",
            "--animation-delay": "0.5s",
            "--animation-duration": "4s",
          } as CSSProperties
        }
      />
      <div
        className="position-relative align-items-end mt-4 mx-auto animate-order"
        style={{ height: "190px", width: "90%" }}
      >
        {map(groups?.slice(0, 5), (player, index) => {
          return (
            <RankElement
              key={get(player, "id", `no${index + 1}`)}
              rank={index + 1}
              player={player}
            />
          );
        })}
      </div>
      <div id="first-round-table" className="mt-3">
        <div
          className={`row row-cols-2 g-4 mt-0 border-between`}
          style={
            {
              fontSize: "1.5rem",
              "--text-gradient":
                "linear-gradient(180deg, #FFFFFF 50%, #9C9C9C 100%)",
            } as CSSProperties
          }
        >
          {map(chunk(groups?.slice(5, 25), 10), (group, index) => (
            <div key={index} className="col mt-0">
              <Table
                // header={group.name}
                items={group}
                cols={cols}
                startRank={index * 10 + 6}
                colorFirst
                // titles={titles}
              />
            </div>
          ))}
        </div>
      </div>
      <img
        alt="coin"
        src="/assets/coin2.png"
        className="animate-floating position-absolute"
        width={80}
        style={
          {
            bottom: "-7%",
            left: "47%",
            rotate: "20deg",
            "--animation-delay": "0.5s",
            "--animation-duration": "3s",
          } as CSSProperties
        }
      />
    </div>
  );
}

export function RankElement(props: {
  rank: number;
  player: { name: string; chip: number };
}) {
  const [position, setPosition] = useState(0);

  useEffect(() => {
    setPosition((get(ranking, props.rank - 1).order - 1) * 20);
  }, [props.rank]); // ติดตามการเปลี่ยนแปลงของ `rank`
  return (
    <div
      className={`rank-${props.rank} fw-bold`}
      style={{
        width: "20%",
        fontSize: `${2 - Math.floor(props.rank / 2) * 0.2}rem`,
        left: `${position}%`, // ใช้ `state` ในการกำหนดตำแหน่ง
        transition: "left 1.25s ease-in-out", // ทำให้การเคลื่อนที่ราบรื่น
      }}
    >
      <img
        alt="pool-light"
        src="/assets/rewards-light.png?v=1"
        className={`position-absolute start-50 translate-middle-x`}
        style={{ width: "160%", bottom: "-15%" }}
      />
      <div className="position-relative d-flex flex-column justify-content-end align-items-center">
        <span className="text-center">{props.player.name}</span>
        <span className="mb-2 lh-1" style={{ fontSize: "0.9em" }}>
          <AnimationNumber value={props.player.chip} />
        </span>
        <img
          alt={`no${props.rank}`}
          src={`/assets/stand-${props.rank}.png?v=1`}
          style={{ width: "60%", height: "auto" }}
        />
      </div>
    </div>
  );
}

export default FirstRound;
